import type { ViewOnlyProductProps } from "./viewOnlyProduct/index";
import { Markup } from "@components/atoms/markup/index.client";
import BaseProduct from "./baseProduct/index.client";

function MarkupRender({ product }) {
  const { totalInventory, tags } = product;

  if (tags.includes("Limited Edition") || tags.includes("Limited Time")) {
    return (
      <Markup color="black" background>
       LIMITED EDITION
      </Markup>
    );
  }

  if (totalInventory === 0) {
    return (
      <Markup color="grey" background>
        Out of stock
      </Markup>
    );
  }

  if (totalInventory <= 10) {
    return (
      <Markup color="yellow">
        Only {totalInventory} left!
      </Markup>
    );
  }

  return <div className="invisible"/>
}

export function Product(props: ViewOnlyProductProps) {
  const { product } = props;
  return (
    <BaseProduct
      {...props}
      aboutStockText={<MarkupRender product={product} />}
      addToCardButton
    />
  );
}
